<template>
  <div>
    <h4 class="pb-3">Contacto para socios</h4>

    <h5>Email</h5>
    <p>El método principal de comunicación con el AMPA es por email. Para cualquier duda, sugerencia o problema, escríbenos a <a href="mailto:socios@ampa-pablo-picasso.es">socios@ampa-pablo-picasso.es</a></p>

    <h5>Canales de WhatsApp y Telegram</h5>
    <p>Tenemos grupos de difusión en WhatsApp y Telegram desde el que enviamos comunicaciones y novedades para todos los
    socios.</p>
    <ul>
    <li>Pulsa <a href="https://chat.whatsapp.com/KFuVeQZWioFKdgf2yl3sI5">aquí</a> para unirte a nuestro grupo de WhatsApp</li>
    <li>Pulsa <a href="https://t.me/ampapablopicasso">aquí</a> para unirte a nuestro grupo de Telegram</li>
    </ul>

    <h5>Teléfono / WhatsApp</h5>
    <p>Aunque en cursos anteriores podíais contactar con el AMPA por teléfono o WhatsApp, nos resulta imposible atenderlo adecuadamente, ya que somos padres y madres voluntarios que trabajamos y no tenemos suficiente tiempo libre. Para cualquier solicitud o consulta, por favor utiliza el email.</p>

  </div>
</template>

<script>

export default {
	name: 'SociosContacto',
}
</script>
